import React, { useEffect, useState } from "react";
import "./index.css";

const ButtonSwitcher = ({ buttonsGroup, currentTab, onSwitch, hex, white }) => {
  const [activeBtn, setActiveBtn] = useState("");
  useEffect(() => {
    setActiveBtn(buttonsGroup[0]);
  }, []);
  useEffect(() => {
    setActiveBtn(currentTab);
  }, [currentTab]);
  const handleClickButton = (buttonName) => {
    setActiveBtn(buttonName);
    onSwitch(buttonName);
  };
  return (
    <div className="d-flex flex-row align-items-center justify-content-center">
      {buttonsGroup.map((item, index) => {
        return (
          <button
            key={index}
            className="btn m-1 btn-white switch-button"
            style={{
              "--hex-color": item === activeBtn ? hex || "#faff87" : "white",
              color: item === activeBtn ? (white ? "white" : "black") : "black",
            }}
            onClick={() => handleClickButton(item)}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
};
export default ButtonSwitcher;



// WEBPACK FOOTER //
// ./src/components/ButtonSwitcher/index.js